export const ADD_ENTITY_TEXT = `New Sponsored Message`;
export const DEFAULT_ENTITY_NAME = `Untitled Sponsored Message`;
